import './faro'
import 'reflect-metadata'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app/App.tsx'
import './index.css'
import './shared/ui/table-select-dropdown/tableSelectDropdown.scss'
import './global-style/fallback.scss'

if (
    import.meta.env.VITE_LOCAL_STORAGE_VERSION !=
    localStorage.getItem('LOCAL_STORAGE_VERSION')
) {
    localStorage.clear()
    localStorage.setItem(
        'LOCAL_STORAGE_VERSION',
        import.meta.env.VITE_LOCAL_STORAGE_VERSION
    )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)
